export const listBgColor = '#fff'
export const listBorderColor = '#d6d1d1'

// TODO: move this to component helpers folder or something
export const clearfix = () => `
  zoom: 1;
  &:before, &:after {
    content: ''; display: table; zoom: 1;
  }
  &:after {
    clear: both;
  }
`
